<template>
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <!--添加门店-->
      <div class="common-form">阿里云号码隐私保护</div>
      <el-form-item label="accessKeyId">
        <el-input v-model="form.accessKeyId" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="accessKeySecret">
        <el-input v-model="form.accessKeySecret" type="password" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="URL">
        <el-input v-model="form.url" class="max-w460"></el-input>
      </el-form-item>

      <!-- <el-form-item label="">
        <el-switch v-model="obj.service_is_open" active-color="#13ce66" inactive-color="#ff4949" active-text="开" inactive-text="关" active-value="1" inactive-value="0">
        </el-switch>

        <div>注：如开启则显示隐私号码拨打，关闭则不显示</div>
      </el-form-item> -->
      <el-form-item label="状态">
        <el-radio-group v-model="form.is_open">
          <el-radio label="0">关闭</el-radio>
          <el-radio label="1">开启</el-radio>
        </el-radio-group>
        <div style="color:#ff6f06">注：如开启则显示隐私号码拨打，关闭则不显示</div>
      </el-form-item>
      <!-- <div class="common-form">短信模板</div>
      <el-form-item label="注册短信模板">
        <el-input v-model="form.login_template" class="max-w460"></el-input>
        <div class="tips">
          不填则表示不支持h5登录
        </div>
      </el-form-item>
      <el-form-item label="商户申请短信模板">
        <el-input v-model="form.apply_template" class="max-w460"></el-input>
        <div class="tips">
          如果不开启手机验证可以不用填写
        </div>
      </el-form-item>
      <el-form-item label="商户审核未通过短信模板">
        <el-input v-model="form.supplier_reject_code" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户审核通过短信模板">
        <el-input v-model="form.supplier_pass_code" class="max-w460"></el-input>
      </el-form-item> -->
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>

  </div>
</template>

<script>
import SettingApi from "@/api/setting.js";

export default {
  data() {
    return {
      /*form表单数据*/
      form: {
        accessKeyId: "", //accessKeyId
        accessKeySecret: "", //accessKeySecret
        url: "",
        is_open: "0"
      },
      loading: false
    };
  },
  created() {
    this.getData();
  },

  methods: {
    getData() {
      let self = this;
      SettingApi.dyplsapi({}, true)
        .then(data => {
          let vars = data.data.vars.values;
          self.form = data.data.vars.values;
        })
        .catch(error => { });
    },
    //提交表单
    onSubmit() {
      let self = this;
      self.loading = true;
      let params = this.form;
      SettingApi.editdyplsapi(params, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: "恭喜你，设置成功",
            type: "success"
          });
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>

<style>
.tips {
  color: #ccc;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/alismg/index.vue